import { yup } from '@guiker/yup-util'

export const sourceSchema = yup.object({
  brokerage: yup.string().nullable(),
  mlsNumber: yup.string().nullable(),
})
